import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {ButtonNew} from '@components/common/base/buttons'
import {DateRangePicker} from '@components/common/date-picker-old/date-range-picker'
import {CrmAnalyticsStore} from '@components/statistics/crm-analytics/crm-analytics-store'

export const CreatedAtDropdown = observer(
  ({crmAnalyticsStore}: {crmAnalyticsStore: CrmAnalyticsStore}) => {
    const initialDates: [Date, Date] | undefined =
      crmAnalyticsStore.dateFilter?.length === 2
        ? [
            Time.toLocalDate(crmAnalyticsStore.dateFilter[0]),
            Time.toLocalDate(crmAnalyticsStore.dateFilter[1])
          ]
        : undefined

    const clearFilter = () => {
      crmAnalyticsStore.setDateFilter(undefined)
    }

    const onChoose = (range: [Date, Date]) => {
      const start = new Date(range[0])
      start.setHours(0, 0, 0, 0)

      const end = new Date(range[1])
      end.setHours(23, 59, 59, 999)

      crmAnalyticsStore.setDateFilter([
        Time.toTimestamp(start),
        Time.toTimestamp(end)
      ])
    }

    return (
      <div className="w-[275px] p-10 bg-primary rounded-8">
        <div className="flex justify-center items-center mb-8 h-30">
          {!!crmAnalyticsStore.dateFilter ? (
            <ButtonNew
              onClick={clearFilter}
              icon="IconCustomClose"
              title={Lang.msg.crm.analytics.clearFilter}
            />
          ) : (
            <div className="text-grey-l20 text-center text-12">
              {Lang.msg.crm.analytics.filterHint}
            </div>
          )}
        </div>
        <div className="sticker-item-list-body mb-6">
          <DateRangePicker onChoose={onChoose} initialDates={initialDates} />
        </div>
      </div>
    )
  }
)
